import styles from './styles.module.scss';
import { NavLink, useLocation } from 'react-router-dom';
import { BreakpointMobileUp, PathnamesMap } from '../../constants/ui';

const NavItem = ({ title, titleMobile, Icon, link, selectedDate, widthViewport, isNew }) => {
  const { pathname } = useLocation();
  return (
    <li className={styles.menuItem}>
      <NavLink
        to={{
          pathname: link,
          search: link === 'maps' ? `?date=${selectedDate}` : '',
        }}
        className={({ isActive }) =>
          isActive ||
          (link === 'sensors' &&
            (pathname.includes(PathnamesMap.timeline) ||
              pathname.includes(PathnamesMap.photo) ||
              pathname.includes(PathnamesMap.charts))) ||
          (link === 'map' && pathname.includes(PathnamesMap.navigator))
            ? `${styles.menuLink} ${styles.menuLinkActive}`
            : styles.menuLink
        }
      >
        <span className={styles.menuLinkIcon}>
          <Icon />
        </span>
        {widthViewport < BreakpointMobileUp && !!titleMobile ? titleMobile : title}
        {isNew && <div className={styles.menuItemLabel}>New</div>}
      </NavLink>
    </li>
  );
};

export default NavItem;
